module.exports = __webpack_public_path__ + "img/Top-Reviewed-Restaurants-e1481657780925.ff21d899.png";